import D, { isPhoneContextValid as S$1, PLUS_SIGN as v, RFC3966_PREFIX_ as l, RFC3966_PHONE_CONTEXT_ as a, RFC3966_ISDN_SUBADDRESS_ as u } from './contact-channels188.js';
import g from './contact-channels155.js';

function S(r,_){var f=_.extractFormattedPhoneNumber,e=D(r);if(!S$1(e))throw new g("NOT_A_NUMBER");var t;if(e===null)t=f(r)||"";else {t="",e.charAt(0)===v&&(t+=e);var n=r.indexOf(l),o;n>=0?o=n+l.length:o=0;var h=r.indexOf(a);t+=r.substring(o,h);}var i=t.indexOf(u);if(i>0&&(t=t.substring(0,i)),t!=="")return t}

export { S as default };
//# sourceMappingURL=contact-channels187.js.map
